/* eslint-disable arrow-body-style */

import React from 'react';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Popover } from '@abyss/web/ui/Popover';
import { NumberSelector } from '@src/common/NumberSelector/NumberSelector';
import { laIpAddressType } from '../../laIpAddressType';
import {
  linkAnalysisFilterPanelApi,
  useLinkAnalysisFilterPanelStore,
} from '../../mothership/linkAnalysisFilterPanel.state';
import { linkAnalysisId } from '../../types';
import { MIN_MAX_CONNECTIONS } from '../../mothership/getValidatedConnectionsValue';

export const IpConnectionsField = () => {
  const value = useLinkAnalysisFilterPanelStore((state) => {
    return state.maxIpConnections;
  });

  const disabled = !useLinkAnalysisFilterPanelStore((state) => {
    return state.nodesSelected;
  }).includes(laIpAddressType);

  const leftBtnDisabled = value === '';
  const rightBtnDisabled = value === `${MIN_MAX_CONNECTIONS.max}`;

  const {
    setMaxConnectionsValue,
    incrementMaxConnectionsValue,
    decrementMaxConnectionsValue,
  } = linkAnalysisFilterPanelApi;

  const label = 'Max Connections per IP';

  return (
    <div data-cy={`${linkAnalysisId}IpConnectionsField`} data-value={value}>
      <div id="laIpConnections">
        <div id="laIpConnectionsLabel">
          <span id="laIpConnectionsLabelText">{label}</span>
          <Popover content="Exclude IP nodes with many connections.">
            <IconSymbol icon="help" variant="fill" />
          </Popover>
        </div>

        <NumberSelector
          hiddenLabel={label}
          value={value}
          disabled={disabled}
          leftBtnDisabled={leftBtnDisabled}
          rightBtnDisabled={rightBtnDisabled}
          placeholder="All"
          onChange={setMaxConnectionsValue}
          onIncrement={incrementMaxConnectionsValue}
          onDecrement={decrementMaxConnectionsValue}
        />
      </div>
    </div>
  );
};
